<span class="ml-2" data-toggle="tooltip"
      i18n-matTooltip="rent period tooltip"
      matTooltip="The minimum rent period on Blitzshare in general is 1 day. Any rent period below one day will be rounded up to a full day. After that, billing is done by the minute.">
                  <mat-icon aria-hidden="false">help_outline</mat-icon>

</span>
